/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-12-17 14:06:50
 * @LastEditTime: 2021-03-04 14:34:42
 */
import http from '@/axios/http'

export function getHistoryAlarm(data) {
  return http({
    url: '/api2/alarmRecord/query',
    method: 'post',
    data,
  })
}
export function getHistoryAlarmAll(data) {
  return http({
    url: '/api2/alarmRecord/queryAll',
    method: 'post',
    data,
  })
}
